export const none = (arr: any[], callback: $TSFixMeFunction) => !arr.some(callback);
